import { ActivityHeatmap } from '@kodprep/platform-ui'
import type { HomeHeatCell, HomeStreak } from '@/lib/api/home'

interface Props {
  heatmap: HomeHeatCell[]
  streak: HomeStreak
}

export function ProgressActivityCard({ heatmap, streak }: Props) {
  const totalActiveDays = heatmap.filter((c) => c.count > 0).length

  return (
    <section className="rounded-xl border border-[#e8e4df] bg-white p-6" aria-label="Activity">
      <p className="text-[11px] font-bold uppercase tracking-wide text-muted-foreground mb-4">
        Activity — 52 weeks
      </p>
      <ActivityHeatmap data={heatmap} columns={52} />
      <div className="mt-4 flex gap-4 border-t border-[#e8e4df] pt-4">
        <div className="text-center">
          <p className="font-heading text-xl font-bold text-[#1a1714]">
            <span aria-hidden="true">🔥</span> {streak.current}
          </p>
          <p className="text-[10px] uppercase tracking-wider text-[#9a9589]">Current Streak</p>
        </div>
        <div className="text-center">
          <p className="font-heading text-xl font-bold text-[#1a1714]">{streak.longest}</p>
          <p className="text-[10px] uppercase tracking-wider text-[#9a9589]">Longest Streak</p>
        </div>
        <div className="text-center">
          <p className="font-heading text-xl font-bold text-[#1a1714]">{totalActiveDays}</p>
          <p className="text-[10px] uppercase tracking-wider text-[#9a9589]">Active Days</p>
        </div>
      </div>
    </section>
  )
}
